module.exports = __webpack_public_path__ + "static/img/ico-app-h-72.180ba01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ico-app-h-72.png
// module id = en0F
// module chunks = 1